import {memo, useMemo, useRef} from 'react';
import {CSSTransition} from 'react-transition-group';
import {Video} from '~library/atoms/Video';
import './EventCreateDesign.sass';

const MemoizedVideo = memo(Video);

export const EventCreateBackground = ({showBackground, selectedBackground, setAnimatedBgReady}) => {
  const backgroundRef = useRef(null);

  const renderedBackground = useMemo(
    () => (
      <div
        className="animate__animated event-create-design__background-wrapper"
        style={{
          backgroundImage:
            selectedBackground?.isVideo || !selectedBackground?.src
              ? null
              : `url(${selectedBackground?.src})`,
        }}
        ref={backgroundRef}
        data-qa-id="invitation-background"
      >
        {selectedBackground?.src && selectedBackground?.isVideo && (
          <MemoizedVideo
            src={selectedBackground?.src}
            className="event-create-design__video-background"
            reload
            onCanPlay={() => {
              setAnimatedBgReady(true);
            }}
            options={{
              id: selectedBackground?.id,
            }}
          />
        )}
      </div>
    ),
    [
      selectedBackground?.src,
      selectedBackground?.isVideo,
      selectedBackground?.id,
      setAnimatedBgReady,
    ]
  );

  return (
    <CSSTransition
      in={showBackground}
      timeout={500}
      classNames={{
        enterActive: 'animate__fadeIn',
        enterDone: 'animate__fadeIn',
        exit: 'animate__fadeIn',
        exitActive: 'animate__fadeOut',
        exitDone: 'animate__fadeOut',
      }}
      nodeRef={backgroundRef}
    >
      {renderedBackground}
    </CSSTransition>
  );
};
